import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Badge, Row, Col } from 'antd';
import { assoc, path } from 'ramda';

import { TimeRangeField } from 'components/common/fields/DateTimeFields';
import EventDescription from './EventDescription';
import SotrMeetDescription from './SotrMeetDescription';
import { getName, getId } from 'helpers/fieldsHelpers';

const isAllowedSubmitResult = ({ currentId, event, event: { done } }) => (
    done === false && currentId === path(['responsible', '0', 'id'], event)
);

const getEventInfo = ({ event, date }) => assoc('date', date, event);

export default class EventItem extends Component {
    static propTypes = {
        openModalEvent: PropTypes.func,
        openModalPerson: PropTypes.func,
        openModalSotrMeetUpdate: PropTypes.func,
        openModalProject: PropTypes.func,
        openModalCompany: PropTypes.func,
        event: PropTypes.shape({
            id: PropTypes.number.isRequired,
            text: PropTypes.string,
            withWhom: PropTypes.array,
            type: PropTypes.string,
            timeFrom: PropTypes.string,
            timeTo: PropTypes.string,
        }),
        currentId: PropTypes.number.isRequired,
        isAllowedToEdit: PropTypes.bool,
        order: PropTypes.number,
    };

    render() {
        const { order, event: { withWhom, type }, isAllowedToEdit } = this.props;
        const { openModalPerson, openModalProject, openModalEvent, openModalSotrMeetUpdate, openModalCompany } = this.props;

        const event = getEventInfo(this.props);
        const editSotrMeet = () => openModalSotrMeetUpdate(event);

        return (
            <Row className="calendar-row">
                <Col className="calendar-number">{order}</Col>
                <Col className="calendar-time">
                    <TimeRangeField time={{ from: event.timeFrom, to: event.timeTo }} />

                    { isAllowedSubmitResult(this.props) && (
                        <Badge status="processing" />
                    )}
                </Col>
                <Col className="calendar-desc">
                    { type === 'Event' &&
                        <EventDescription
                            openModalProject={openModalProject}
                            openModalEvent={openModalEvent}
                            openModalCompany={openModalCompany}
                            event={event}
                        />
                    }

                    { type === 'SotrMeet' && <SotrMeetDescription edit={isAllowedToEdit && editSotrMeet} event={event} /> }
                </Col>
                { withWhom && (
                    <Col className="calendar-name">
                        <a onClick={() => openModalPerson({ id: getId(withWhom), value: getName(withWhom)})}>
                            {getName(withWhom)}
                        </a>
                    </Col>
                )}
            </Row>
        );
    }
}
